module.exports = __webpack_public_path__ + "img/bank-15-shinhyup.c19fe10b.svg";